<template>
  <section class="referal">
    <div class="referal-header _mb-12">
      <div class="referal-header__text _mr-4 _mr-sm-0 _mb-sm-8">
        <div class="_mb-4 _fs-24 _lh-32 _fw-700 _tc-dark">
          Реферальная программа
        </div>
        <div class="_fs-16 _lh-24">
          За регистрацию пользователя по вашей индивидуальной ссылке вы
          получаете 30 коинов.
          <div class="d-flex _mt-4">
            <div class="_mr-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  stroke="#DC8633"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div
              class="_my-auto"
              v-if="ServerTime && Object.keys(ServerTime).length"
            >
              Акция действует до {{ openProgram.end_date.getDate() }}

              {{
                $t(`interface.monthsNoun[${openProgram.end_date.getMonth()}]`)
              }}.
            </div>
          </div>
        </div>
      </div>
      <div class="referal-header__stat _ml-4 _ml-md-0 _ml-sm-0">
        <div class="referal-header__stat-el _mr-8 _mr-sm-7">
          <div class="referal-header__stat-container _mr-4 _mr-md-0">
            <div
              class="referal-header__stat-num _fs-30 _lh-42 _fw-500 _mr-2"
              v-if="user.invites"
            >
              {{ user.invites.length || 0 }}
            </div>
            <div class="referal-header__stat-icon">
              <img :src="require('@/assets/img/cabinet/user.png')" alt="" />
            </div>
          </div>
          <div class="referal-header__stat-descr _fs-16 _lh-24 _fw-400 _mt-2">
            Регистраций по вашей<br />
            реферальной ссылке
          </div>
        </div>
        <div class="referal-header__stat-el _mr-8 _mr-md-0">
          <div class="referal-header__stat-container _mr-4 _mr-md-0">
            <div
              class="referal-header__stat-num _fs-30 _lh-42 _fw-500 _mr-2"
              v-if="user.invites"
            >
              {{ (user.invites.length || 0) * 30 }}
            </div>
            <div class="referal-header__stat-icon">
              <img
                :src="require('@/assets/img/leaderboard/coins.png')"
                alt=""
              />
            </div>
          </div>
          <div class="referal-header__stat-descr _fs-16 _lh-24 _fw-400 _mt-2">
            Коинов зачислено<br />
            за завершение регистрации
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex direction-column direction-md-row _mb-12"
      v-if="ServerTime && Object.keys(ServerTime).length"
    >
      <div class="_mr-4 _my-auto _mb-sm-4" style="flex-shrink: 0">
        <AppBtn
          @click.native="copyReferralLink"
          :disabled="!referralProgramIsset"
          :btnClass="` ${
            (referralProgramIsset ? '' : 'btn_disabled',
            linkCopied ? 'btn_primary' : 'btn_orange')
          } w-100 w-md-auto`"
        >
          <span class="_tc-white _fs-16 d-flex align-center _pa-2">
            <svg
              class="_mr-2"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 9.5H11C9.89543 9.5 9 10.3954 9 11.5V20.5C9 21.6046 9.89543 22.5 11 22.5H20C21.1046 22.5 22 21.6046 22 20.5V11.5C22 10.3954 21.1046 9.5 20 9.5Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 15.5H4C3.46957 15.5 2.96086 15.2893 2.58579 14.9142C2.21071 14.5391 2 14.0304 2 13.5V4.5C2 3.96957 2.21071 3.46086 2.58579 3.08579C2.96086 2.71071 3.46957 2.5 4 2.5H13C13.5304 2.5 14.0391 2.71071 14.4142 3.08579C14.7893 3.46086 15 3.96957 15 4.5V5.5"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            {{ linkCopied ? "Ссылка скопирована" : "Скопировать ссылку" }}
          </span>
        </AppBtn>
      </div>
      <div class="_fs-16 _lh-24 _tc-light-gray">
        Скопируйте свою индивидуальную ссылку и отправьте в мессенджеры членам
        своей организации, чтобы они смогли зарегистрироваться в Herbalife
        Академии.
      </div>
    </div>
    <div
      class="referal__table-title _mb-4 _fs-32 _fs-sm-24 _lh-38 _fw-700 _tc-dark"
    >
      Статистика реферальной программы
    </div>
    <div class="container _py-16 _py-sm-0">
      <div class="referal__table">
        <div
          class="referal__table-item"
          v-for="(item, i) in user.invites"
          :key="i"
        >
          <div
            class="d-md-none _fs-20 _fs-sm-16 _lh-24 _fw-600 _tc-green-second referal__table-item-check"
          >
            <div
              class="referal__table-item-check"
              :data-head="'Имя пользователя'"
            >
              {{ item.first_name }} {{ item.last_name }}
            </div>
          </div>
          <div
            class="referal__table-item-number _mr-12 _mr-sm-0"
            :data-head="'ID'"
          >
            <span class="_fs-20 _fs-sm-16 _lh-24 _fw-600 _tc-green-second">{{
              item.username
            }}</span>
          </div>
          <!-- <div class="referal__table-item-container"> -->
          <div class="">
            <div
              class="referal__table-item-check d-none d-md-flex"
              :data-head="'Имя пользователя'"
            >
              {{ item.first_name }} {{ item.last_name }}
            </div>
          </div>
          <div class="referal__table-item-date" :data-head="'Дата регистрации'">
            <span>{{ formatDate(item.first_login_date) }}</span>
          </div>

          <div>
            <div class="referal__table-item-coins" :data-head="'Коины'">
              <div class="d-flex align-center">
                <img :src="require('@/assets/img/leaderboard/coins.png')" />
                <div class="referal__table-item-coins-count">30</div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AppBtn from "../../components/UI/buttons/AppBtn.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  metaInfo() {
    return { title: this.$t("cabinet.dashboard.menu[6]") };
  },
  name: "Referal",
  components: {
    AppBtn,
  },
  data: () => ({
    linkCopied: false,
  }),
  computed: {
    ...mapGetters(["user", "ServerTime"]),
    referralProgramIsset() {
      return this.ServerTime.active;
    },
    openProgram() {
      return {
        end_date: new Date(this.ServerTime.display_time),
      };
    },
  },
  methods: {
    ...mapActions(["fetchInvite", "fetchServerTime"]),
    copyReferralLink() {
      var copyText = `Подключайтесь к обучению с Herbalife Академией, чтобы получить доступ к тренингам и полезным материалам по бизнесу и продуктам. \n\n${
        window.location.origin + "/register/" + this.user.referral_code
      }`;
      navigator.clipboard.writeText(copyText);
      this.linkCopied = true;
      setTimeout(() => {
        this.linkCopied = false;
      }, 2000);
    },
    formatDate(dateString) {
      if (!dateString) {
        return "";
      }
      let date = new Date(dateString);
      return `${date.getDate().toString().padStart(2, 0)}.${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, 0)}.${date.getFullYear()}`;
    },
  },
  created() {},
  async mounted() {
    await this.fetchInvite();
    await this.fetchServerTime();
  },
};
</script>

<style lang="scss" scoped>
.referal {
  &-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 32px;
    border-bottom: 1px solid #c7c9c7;
    @media screen and (max-width: 1220px) {
      //   align-items: flex-end;
      flex-direction: column;
    }
    @media screen and (max-width: 743px) {
      flex-direction: column;
      align-items: flex-start;
    }
    &__text {
      width: 50%;
      @media screen and (max-width: 1220px) {
        width: 100%;
      }
    }
    &__stat {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: 1220px) {
        align-items: flex-start;
        margin-top: 40px;
      }
      &-el {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        @media screen and(max-width: 767px) {
          align-items: center;
        }
      }
      &-descr {
        @media screen and(max-width: 767px) {
          text-align: center;
        }
        br {
          @media screen and(max-width: 1220px) {
            display: none;
          }
        }
      }
      &-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        border: 1px solid #d1d2cd;
        border-radius: 99px;
        padding: 9px 16px;
        @media screen and (max-width: 1220px) {
        }
        @media screen and (max-width: 743px) {
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }
      &-icon {
        width: 40px;
        height: 40px;
      }
    }
  }
  &__table {
    &-item {
      padding: 15px 30px;
      background: #ffffff;
      border: 1px solid #77bb2f;
      border-radius: 16px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-content: flex-start;
      align-items: center;
      min-height: 87px;
      margin-bottom: 8px;
      column-gap: 32px;

      @media screen and (max-width: 1220px) {
        grid-template-columns: 1fr 1fr 1fr 0.5fr;
      }

      @media screen and (max-width: 767px) {
        padding: 16px;
        grid-template-columns: 1fr 0.5fr;
        grid-template-rows: repeat(2, auto);
        gap: 0;
      }

      &-number {
        position: relative;
        // width: 63px;
        height: 45px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 767px) {
          display: flex;

          &::before {
            position: static;
            margin-right: 8px;
            width: auto !important;
          }
        }
      }

      &-date {
        position: relative;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "Noto-Sans", sans-serif;
        font-style: normal;
        // font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        // color: #54585a;
        &::before {
          left: 50% !important;
          transform: translateX(-50%) !important;
        }
        @media screen and (max-width: 1220px) {
          justify-content: flex-start;
        }
        @media screen and (max-width: 767px) {
          margin-left: 0;
          display: block;
        }
      }

      &-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-content: flex-start;
        align-items: center;

        @media screen and (max-width: 1220px) {
          grid-template-columns: 1fr 0.5fr 1fr;
        }
      }

      &-check {
        height: 45px;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &::before {
          @media screen and (max-width: 767px) {
            text-align: left;
          }
        }
        @media screen and (max-width: 767px) {
          margin: 0;
          display: block;
          grid-column-start: 1;
          grid-column-end: 3;
          height: auto;
          &::before {
            display: none !important;
          }
        }
        & img {
          width: 45px;
          margin-right: 8px;
          @media screen and (max-width: 767px) {
            width: 20px;
          }
        }
        &-count {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 28px;
          height: 28px;
          background: #ffffff;
          padding: 8px;
          border-radius: 50%;
          border: 1px solid #c7c9c7;
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          text-align: center;
          color: #25282a;
          @media screen and (max-width: 767px) {
            margin-right: 8px;
            padding: 0;
            border-radius: 0;
            background: transparent;
            border: 0;
            width: auto;
            height: auto;
            font-size: 12px;
            line-height: 12px;

            text-align: left;

            color: #629727;
          }
        }

        &-container {
          display: grid;
          grid-template-columns: 1fr 1fr;
          justify-content: flex-start;
          align-items: center;
        }
      }

      &-coins {
        position: relative;
        margin-left: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 1220px) {
          justify-content: flex-start;
        }
        @media screen and (max-width: 767px) {
          display: block;
          height: 45px;
        }
        &::before {
          left: 50% !important;
          transform: translateX(-50%) !important;
        }
        & img {
          width: 45px;
          margin-right: 8px;
          @media screen and (max-width: 767px) {
            width: 26px;
          }
        }
        &-count {
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #54585a;
          @media screen and (max-width: 767px) {
            color: #629727;
          }
        }
      }

      &:first-child {
        & *[data-head] {
          &::before {
            display: block;
            white-space: nowrap;
            @media screen and (max-width: 1220px) {
              top: -75px;
              width: 100%;
            }
          }
        }
      }
      & *[data-head] {
        &::before {
          position: absolute;
          top: -60px;
          left: 0;
          display: none;
          font-family: "Noto-Sans", sans-serif;
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          color: #b2b4b2;
          content: attr(data-head) "";
          @media screen and (max-width: 767px) {
            display: block;
            position: static;
            transform: none !important;
            font-size: 14px;
          }
        }
      }
    }
  }
  //   .btn.btn-share {
  //     display: flex;
  //     flex-direction: row;
  //     padding: 7px 12px;
  //     max-width: fit-content;
  //     color: #ffffff;
  //     svg {
  //       margin-right: 8px;
  //     }
  //   }
}
</style>
